//get Bonus Content
export const GET_BONUS = "GET_BONUS";

//Insert Bonus Content
export const INSERT_BONUS = "INSERT_BONUS";

//Update Bonus Content
export const UPDATE_BONUS = "UPDATE_BONUS";

//Update Bonus Content Status
export const UPDATE_BONUS_STATUS = "UPDATE_BONUS_STATUS";

//Delete Bonus Content
export const DELETE_BONUS = "DELETE_BONUS";

//DRM Selection Dialog
export const OPEN_BONUS_DRM_DIALOG = "OPEN_BONUS_DRM_DIALOG";
export const CLOSE_BONUS_DRM_DIALOG = "CLOSE_BONUS_DRM_DIALOG";

//toast
export const OPEN_BONUS_TOAST = "OPEN_BONUS_TOAST";
export const CLOSE_BONUS_TOAST = "CLOSE_BONUS_TOAST";

const uploadFileTypes = {
  SET_UPLOAD_FILE: "BONUS_SET_UPLOAD_FILE",

  SET_UPLOAD_PROGRESS: "BONUS_SET_UPLOAD_PROGRESS",
  SUCCESS_UPLOAD_FILE: "BONUS_SUCCESS_UPLOAD_FILE",
  FAILURE_UPLOAD_FILE: "BONUS_FAILURE_UPLOAD_FILE",
};

export default uploadFileTypes;
